import { render } from "./DisasterRecoveryClusterVmTab.vue?vue&type=template&id=53af16a1&scoped=true"
import script from "./DisasterRecoveryClusterVmTab.vue?vue&type=script&lang=js"
export * from "./DisasterRecoveryClusterVmTab.vue?vue&type=script&lang=js"

import "./DisasterRecoveryClusterVmTab.vue?vue&type=style&index=0&id=53af16a1&lang=scss&scoped=true"
import "./DisasterRecoveryClusterVmTab.vue?vue&type=style&index=1&id=53af16a1&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53af16a1"]])

export default __exports__